import React from "react";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

type FuelCatalogProps = {
  fuelCatalog: any
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export const FuelCatalogDetailTab: React.FC<FuelCatalogProps> = ({ fuelCatalog }) => {
  return (
    <Stack spacing={2} >
      <Item style={{ marginBottom: '10px', backgroundColor: 'rgba(245, 239, 239, 0.87)' }}>

        <div style={{ marginTop: '30px', marginLeft:'20px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ marginBottom: '1rem', fontWeight: 700, fontSize: '20px', width: '48%', textAlign: 'left', color:'black' }}>{fuelCatalog?.fireDangerModelName}</div>

        </div>
        <div style={{ marginLeft:'20px', minHeight:'60vh', justifyContent: 'space-between' }}>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> Fuel Model Type:</span> {fuelCatalog?.fuelModel}</div>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> Grass Type:</span> {fuelCatalog?.grassType}</div>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> MXD Override:</span> {fuelCatalog?.mxdOverride}</div>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> SCM:</span> {fuelCatalog?.scm}</div>
            <div style={{ marginLeft:'10px', marginBottom: '2rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> Slope Class:</span> {fuelCatalog?.slopeClass}</div>
             <Item style={{ marginBottom: '10px', backgroundColor: 'white', alignContent:'left' }}>
                <div style={{ margin: '30px', marginLeft:'20px', display: 'flex', justifyContent: 'space-between', fontSize:'20px' }}>
                    {fuelCatalog?.droughtCatalog?.name}
                </div>
                
            </Item>
             <Item style={{ marginBottom: '10px', backgroundColor: 'white', alignContent:'left' }}>
                <div style={{ margin: '30px', marginLeft:'20px', display: 'flex', justifyContent: 'space-between', fontSize:'20px' }}>
                    {fuelCatalog?.deadFuelCatalog?.name}
                </div>
                
            </Item>
             <Item style={{ marginBottom: '10px', backgroundColor: 'white', alignContent:'left' }}>
                <div style={{ margin: '30px', marginLeft:'20px', display: 'flex', justifyContent: 'space-between', fontSize:'20px' }}>
                    {fuelCatalog?.liveFuelCatalog?.name}
                </div>
                
            </Item>
        </div>
      </Item>

    </Stack>
  );
}
